const regexCustomURL = /(^$|^\w+$)/;

export default regexCustomURL;
